import { IPublicClientApplication } from '@azure/msal-browser';

/**
 * Retrieves the profile photo of the logged-in user via Microsoft Graph API
 * @param msalInstance - MSAL instance for authentication
 * @returns Promise<string | undefined> - Photo URL in base64 or undefined if error
 */
export const getUserPhoto = async (msalInstance: IPublicClientApplication): Promise<string | undefined> => {
    // Temporarily disabled due to API errors
    return undefined;
    
    /* try {
        const activeAccount = msalInstance.getActiveAccount();
        
        if (!activeAccount) {
            console.warn('No active account found');
            return undefined;
        }

        // Acquire a token for Microsoft Graph
        const tokenRequest = {
            scopes: ['User.Read'],
            account: activeAccount,
        };

        const response = await msalInstance.acquireTokenSilent(tokenRequest);
        
        if (!response?.accessToken) {
            console.warn('Unable to obtain access token');
            return undefined;
        }

        // Call Microsoft Graph API to retrieve the photo
        const graphResponse = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${response.accessToken}`,
            },
        });

        if (!graphResponse.ok) {
            if (graphResponse.status === 404) {
                console.info('No profile photo found for this user');
            } else {
                console.warn(`Error retrieving photo: ${graphResponse.status}`);
            }
            return undefined;
        }

        // Convert response to blob then to data URL
        const photoBlob = await graphResponse.blob();
        const photoUrl = URL.createObjectURL(photoBlob);
        
        // Convert to base64 for more persistent storage
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.readAsDataURL(photoBlob);
        });

    } catch (error) {
        console.error('Error retrieving user photo:', error);
        return undefined;
    } */
};